import {
	createHook,
	createStore,
	createContainer,
	createDefaultEocWrapper,
	createActionsHook,
} from '@atlassian/eoc-rss-helpers';
import { useFlagService } from '@atlassian/jira-flags';
import {
	useIsAdmin,
	useIsSiteAdmin,
	useTenantContext,
} from '@atlassian/jira-tenant-context-controller';
import { actions } from './actions';
import type { TransitioningStatusState, TransitioningStatusStoreContainerProps } from './types';

export const initialState: TransitioningStatusState = {
	loading: false,
	error: null,

	isJnaAppDownloaded: false,
	ogAppExistsAtTransitioningStart: false,
	isRBNEnabled: true,
	areOgRulesDuplicated: false,
	areOgAppsDeactivated: false,
	jnaAppDownloadedRatio: 0,
	jnaAppDownloadedUsersCount: 0,
};

const Store = createStore({ initialState, actions, name: 'transitioning-status' });

const TransitioningStatusContainer = createContainer<
	TransitioningStatusState,
	typeof actions,
	{ children?: React.ReactNode; isGlobal?: boolean }
>(Store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): TransitioningStatusStoreContainerProps => {
			const { cloudId } = useTenantContext();
			const { showFlag } = useFlagService();
			const isSiteAdmin = useIsSiteAdmin();
			const isPrimaryAdmin = useIsAdmin();
			return {
				cloudId,
				showFlag,
				isAdmin: isSiteAdmin || isPrimaryAdmin,
			};
		},
	}),
});

const useTransitioningStatus = createHook(Store);
const useTransitioningStatusActions = createActionsHook(Store);

export { useTransitioningStatus, useTransitioningStatusActions, TransitioningStatusContainer };
